module.exports = __webpack_public_path__ + "static/media/alps.549a82af.png";